// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__OkUPj","head":"Table_head__9-C6p","col":"Table_col__3qV6O"};